<template>
  <p class="v-fallback-text-ui">
    <slot />
  </p>
</template>
